import { EntityType } from '@frontend/common';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const Objects = {
    DECEASED: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.DECEASED.DEFAULT'
                description='Label for deceased'
                defaultMessage='Deceased'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.DECEASED.PLURAL'
                description='Plural name for deceased'
                defaultMessage='Deceased'
            />
        ),
        DATE_OF_DEATH: (
            <FormattedMessage
                id='Objects.DECEASED.DATE_OF_DEATH'
                description='Label for deceased date of death'
                defaultMessage='Date of death'
            />
        ),
        ELYS_NUMBER: (
            <FormattedMessage
                id='Objects.DECEASED.ELYS_NUMBER'
                description='Label for deceased eLys number'
                defaultMessage='eLys'
            />
        ),
        CREMATION: (
            <FormattedMessage
                id='Objects.DECEASED.CREMATION'
                description='Label for deceased cremation timestamp'
                defaultMessage='Cremation'
            />
        )
    },
    RECYCLE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.RECYCLE.DEFAULT'
                description='Label for recycle'
                defaultMessage='Recycle'
            />
        )
    },
    RETURN: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.RETURN.DEFAULT'
                description='Label for return'
                defaultMessage='Return'
            />
        )
    },
    ORDER_ITEM: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.ORDER_ITEM.DEFAULT'
                description='Label for order item'
                defaultMessage='Order item'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.ORDER_ITEM.PLURAL'
                description='Plural name for order items'
                defaultMessage='Order items'
            />
        )
    },
    ORDER: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.ORDER.DEFAULT'
                description='Label for order'
                defaultMessage='Order'
            />
        ),
        ORDER_NUMBER: (
            <FormattedMessage
                id='Objects.ORDER.ORDER_NUMBER'
                description='Label for order number'
                defaultMessage='Order number'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.ORDER.PLURAL'
                description='Plural name for orders'
                defaultMessage='Orders'
            />
        ),
        STATUS_ANY: (
            <FormattedMessage
                id='Objects.ORDER.STATUS_ANY'
                description='Order state: any state'
                defaultMessage='Any state'
            />
        ),
        STATUS_PENDING: (
            <FormattedMessage
                id='Objects.ORDER.STATUS_PENDING'
                description='Order state: pending'
                defaultMessage='Pending'
            />
        ),
        STATUS_PROCESSING: (
            <FormattedMessage
                id='Objects.ORDER.STATUS_PROCESSING'
                description='Order state: processing'
                defaultMessage='Processing'
            />
        ),
        STATUS_COMPLETED: (
            <FormattedMessage
                id='Objects.ORDER.STATUS_COMPLETED'
                description='Order state: completed'
                defaultMessage='Completed'
            />
        ),
        STATUS_CANCELLED: (
            <FormattedMessage
                id='Objects.ORDER.STATUS_CANCELLED'
                description='Order state: cancelled'
                defaultMessage='Cancelled'
            />
        )
    },
    BASKET: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.BASKET.DEFAULT'
                description='Label for basket'
                defaultMessage='Basket'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.BASKET.PLURAL'
                description='Plural name for baskets'
                defaultMessage='Baskets'
            />
        )
    },
    BASKET_ITEM: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.BASKET_ITEM.DEFAULT'
                description='Label for basket item'
                defaultMessage='Basket item'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.BASKET_ITEM.PLURAL'
                description='Plural name for basket items'
                defaultMessage='Basket items'
            />
        )
    },
    INVITE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.INVITE.DEFAULT'
                description='Label for invite'
                defaultMessage='Invite'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.INVITE.PLURAL'
                description='Plural name for invites'
                defaultMessage='Invites'
            />
        )
    },
    DOCKER_IMAGE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.DOCKER_IMAGE.DEFAULT'
                description='Label for docker image'
                defaultMessage='Docker Image'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.DOCKER_IMAGE.PLURAL'
                description='Plural name for docker images'
                defaultMessage='Docker Images'
            />
        )
    },
    SECTION: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.SECTION.DEFAULT'
                description='Label for section'
                defaultMessage='Section'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.SECTION.PLURAL'
                description='Plural name for sections'
                defaultMessage='Sections'
            />
        )
    },
    TEST_RUN: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.TEST_RUN.DEFAULT'
                description='Label for test run'
                defaultMessage='Test run'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.TEST_RUN.PLURAL'
                description='Plural name for test runs'
                defaultMessage='Test runs'
            />
        )
    },
    INSIGHT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.INSIGHT.DEFAULT'
                description='Label for insight'
                defaultMessage='Insight'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.INSIGHT.PLURAL'
                description='Plural name for insights'
                defaultMessage='Insights'
            />
        )
    },
    AUDIT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.AUDIT'
                description='Label for audit'
                defaultMessage='Audit'
            />
        ),
        LOGS: (
            <FormattedMessage
                id='Objects.AUDIT.LOGS'
                description='Label for audit logs'
                defaultMessage='Audit logs'
            />
        )
    },
    BARCODE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.BARCODE.DEFAULT'
                description='Label for barcode'
                defaultMessage='Barcode'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.BARCODE.PLURAL'
                description='Plural name for barcodes'
                defaultMessage='Barcodes'
            />
        )
    },
    CONFIGURATION: (
        <FormattedMessage
            id='Objects.CONFIGURATION.DEFAULT'
            description='Label for configuration'
            defaultMessage='Configuration'
        />
    ),
    LABEL: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.LABEL.DEFAULT'
                description='Label for label'
                defaultMessage='Label'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.LABEL.PLURAL'
                description='Plural name for labels'
                defaultMessage='Labels'
            />
        )
    },
    APPLICATION: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.APPLICATION.DEFAULT'
                description='Label for application'
                defaultMessage='Application'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.APPLICATION.PLURAL'
                description='Plural name for applications'
                defaultMessage='Applications'
            />
        )
    },
    COLLI: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.COLLI.DEFAULT'
                description='Label for colli'
                defaultMessage='Colli'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.COLLI.PLURAL'
                description='Plural name for collis'
                defaultMessage='Collis'
            />
        ),
        HISTORY_LOG: {
            CREATED: (
                <FormattedMessage
                    id='Objects.COLLI.HISTORY_LOG.CREATED'
                    description='History timeline label when a colli was created'
                    defaultMessage='Colli created'
                />
            ),
            COMPLETED: (
                <FormattedMessage
                    id='Objects.COLLI.HISTORY_LOG.COMPLETED'
                    description='History timeline label when a colli was completed'
                    defaultMessage='Colli completed'
                />
            ),
            DROPPED_OFF: (
                <FormattedMessage
                    id='Objects.COLLI.HISTORY_LOG.DROPPED_OFF'
                    description='History timeline label when a colli was dropped off'
                    defaultMessage='Colli dropped off'
                />
            ),
            PICKED_UP: (
                <FormattedMessage
                    id='Objects.COLLI.HISTORY_LOG.PICKED_UP'
                    description='History timeline label when a colli was picked up'
                    defaultMessage='Colli picked up'
                />
            )
        }
    },
    COLLI_CONTENT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.COLLI_CONTENT.DEFAULT'
                description='Label for colli content'
                defaultMessage='Colli content'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.COLLI_CONTENT.PLURAL'
                description='Plural name for colli contents'
                defaultMessage='Colli contents'
            />
        )
    },
    DEFAULT: {
        CREATION_TIMESTAMP: (
            <FormattedMessage
                id='ContactList.Table.Title.CreationTimestamp'
                description='Table title for creation date'
                defaultMessage='Created date'
            />
        ),
        UPDATE_TIMESTAMP: (
            <FormattedMessage
                id='Objects.DEFAULT.UPDATE_TIMESTAMP'
                description='Table title for update date'
                defaultMessage='Updated date'
            />
        ),
        VALID_TIMESTAMP: (
            <FormattedMessage
                id='Objects.DEFAULT.VALID_TIMESTAMP'
                description='Table title for valid date'
                defaultMessage='Valid date'
            />
        ),
        VALID_FROM_TIMESTAMP: (
            <FormattedMessage
                id='Objects.DEFAULT.VALID_FROM_TIMESTAMP'
                description='Table title for valid from date'
                defaultMessage='Valid from'
            />
        ),
        VALID_TO_TIMESTAMP: (
            <FormattedMessage
                id='Objects.DEFAULT.VALID_TO_TIMESTAMP'
                description='Table title for valid to date'
                defaultMessage='Valid to'
            />
        )
    },
    FEATURE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.FEATURE.DEFAULT'
                description='Label for feature'
                defaultMessage='Feature'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.FEATURE.PLURAL'
                description='Plural name for features'
                defaultMessage='Features'
            />
        )
    },
    FUNCTIONALITY: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.FUNCTIONALITY.DEFAULT'
                description='Label for functionality'
                defaultMessage='Functionality'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.FUNCTIONALITY.PLURAL'
                description='Plural name for functionalities'
                defaultMessage='Functionalities'
            />
        )
    },
    LICENSE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.LICENSE.DEFAULT'
                description='Label for license'
                defaultMessage='License'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.LICENSE.PLURAL'
                description='Plural name for licenses'
                defaultMessage='Licenses'
            />
        )
    },
    PRINTER: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.PRINTER.DEFAULT'
                description='Label for printer'
                defaultMessage='Printer'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.PRINTER.PLURAL'
                description='Plural name for printers'
                defaultMessage='Printers'
            />
        ),
        PRINT_TO_CONTINUE: (
            <FormattedMessage
                id='Objects.PRINTER.PRINT_TO_CONTINUE'
                description='Label for print to continue'
                defaultMessage='Print the labels to continue.'
            />
        ),
        PRINT_LABELS: (
            <FormattedMessage
                id='Objects.PRINTER.PRINT_LABELS'
                description='Label for print labels'
                defaultMessage='Print labels'
            />
        ),
        NO_DEFAULT_PRINTER: (
            <FormattedMessage
                id='Objects.PRINTER.NO_DEFAULT_PRINTER'
                description='Label for no default printer'
                defaultMessage='No default printer found. Ask your admin to add a printer.'
            />
        ),
        COPIES: (
            <FormattedMessage
                id='Objects.PRINTER.COPIES'
                description='Label for number of copies'
                defaultMessage='Number of copies'
            />
        )
    },
    REPLENISHMENT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.REPLENISHMENT.DEFAULT'
                description='Label for replenishment'
                defaultMessage='Replenishment'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.REPLENISHMENT.PLURAL'
                description='Plural name for replenishments'
                defaultMessage='Replenishments'
            />
        )
    },
    REPORT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.REPORT.DEFAULT'
                description='Label for report'
                defaultMessage='Report'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.REPORT.PLURAL'
                description='Plural name for reports'
                defaultMessage='Reports'
            />
        )
    },
    REVIEW: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.REVIEW.DEFAULT'
                description='Label for review'
                defaultMessage='Review'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.REVIEW.PLURAL'
                description='Plural name for reviews'
                defaultMessage='Reviews'
            />
        )
    },
    JOB: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.JOB.DEFAULT'
                description='Label for job'
                defaultMessage='Job'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.JOB.PLURAL'
                description='Plural name for jobs'
                defaultMessage='Jobs'
            />
        ),
        GENERATED_AT: (
            <FormattedMessage
                id='Objects.JOB.GENERATED_AT'
                description='label for generated at'
                defaultMessage='Generated at'
            />
        ),
        GENERATED_BY: (
            <FormattedMessage
                id='Objects.JOB.GENERATED_BY'
                description='label for generated by'
                defaultMessage='Generated by'
            />
        )
    },
    NOTIFICATION: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.NOTIFICATION.DEFAULT'
                description='Label for notification'
                defaultMessage='Notification'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.NOTIFICATION.PLURAL'
                description='Plural name for notifications'
                defaultMessage='Notifications'
            />
        )
    },
    NOTIFICATION_CONTENT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.NOTIFICATION_CONTENT.DEFAULT'
                description='Label for notification content'
                defaultMessage='Notification content'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.NOTIFICATION_CONTENT.PLURAL'
                description='Plural name for notification contents'
                defaultMessage='Notification contents'
            />
        )
    },
    NOTIFICATION_TEMPLATE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.NOTIFICATION_TEMPLATE.DEFAULT'
                description='Label for notification template'
                defaultMessage='Notification template'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.NOTIFICATION_TEMPLATE.PLURAL'
                description='Plural name for notification templates'
                defaultMessage='Notification templates'
            />
        )
    },
    NOTIFICATION_EMAIL: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.NOTIFICATION_EMAIL.DEFAULT'
                description='Label for notification email'
                defaultMessage='Notification email'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.NOTIFICATION_EMAIL.PLURAL'
                description='Plural name for notification emails'
                defaultMessage='Notification emails'
            />
        )
    },
    PARCEL: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.PARCEL.DEFAULT'
                description='Label for parcel'
                defaultMessage='Parcel'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.PARCEL.PLURAL'
                description='Plural name for parcels'
                defaultMessage='Parcels'
            />
        )
    },
    VARIABLE: {
        VARIABLE_NAME: typedVariable
    },
    EVENT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.EVENT.DEFAULT'
                description='Label for event'
                defaultMessage='Event'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.EVENT.PLURAL'
                description='Plural name for events'
                defaultMessage='Events'
            />
        ),
        SYNC_EVENTS: (
            <FormattedMessage
                id='Objects.EVENT.SYNC_EVENTS'
                description='Label for sync events'
                defaultMessage='Sync Events'
            />
        )
    },
    SSO_PROVIDER: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.SSO_PROVIDER.DEFAULT'
                description='Label for SSO provider'
                defaultMessage='SSO Provider'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.SSO_PROVIDER.PLURAL'
                description='Plural name for SSO providers'
                defaultMessage='SSO Providers'
            />
        )
    },
    SYNC: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.SYNC.DEFAULT'
                description='Label for sync'
                defaultMessage='Sync'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.SYNC.PLURAL'
                description='Plural name for syncs'
                defaultMessage='Syncs'
            />
        )
    },
    CHANGE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.CHANGE.DEFAULT'
                description='Label for change'
                defaultMessage='Change'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.CHANGE.PLURAL'
                description='Plural name for changes'
                defaultMessage='Changes'
            />
        )
    },
    LABEL_TEMPLATE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.LABEL_TEMPLATE.DEFAULT'
                description='Label for label template'
                defaultMessage='Label template'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.LABEL_TEMPLATE.PLURAL'
                description='Plural name for label templates'
                defaultMessage='Label templates'
            />
        ),
        ROTATE: (
            <FormattedMessage
                id='Objects.LABEL_TEMPLATE.ROTATE'
                description='Label for rotate'
                defaultMessage='Rotate'
            />
        )
    },
    SCHEDULE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.SCHEDULE.DEFAULT'
                description='Label for schedule'
                defaultMessage='Schedule'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.SCHEDULE.PLURAL'
                description='Plural name for schedules'
                defaultMessage='Schedules'
            />
        ),
        RUNS_EVERY: (
            <FormattedMessage
                id='Objects.SCHEDULE.RUNS_EVERY'
                description='Label for schedule runs every'
                defaultMessage='Runs every'
            />
        )
    },
    SCREEN: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.SCREEN.DEFAULT'
                description='Label for screen'
                defaultMessage='Screen'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.SCREEN.PLURAL'
                description='Plural name for screens'
                defaultMessage='Screens'
            />
        )
    },
    SEED: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.SEED.DEFAULT'
                description='Label for seed'
                defaultMessage='Seed'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.SEED.PLURAL'
                description='Plural name for seeds'
                defaultMessage='Seeds'
            />
        )
    },
    STEP: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.STEP.DEFAULT'
                description='Label for step'
                defaultMessage='Step'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.STEP.PLURAL'
                description='Plural name for steps'
                defaultMessage='Steps'
            />
        )
    },
    RULE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.RULE.DEFAULT'
                description='Label for rule'
                defaultMessage='Rule'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.RULE.PLURAL'
                description='Plural name for rules'
                defaultMessage='Rules'
            />
        )
    },
    PIN_CODE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.PIN_CODE.DEFAULT'
                description='Label for PIN-code'
                defaultMessage='PIN-code'
            />
        ),
        YOUR_PICK_UP_CODE: (
            <FormattedMessage
                id='Objects.PIN_CODE.YOUR_PICK_UP_CODE'
                description='Title of the modal that shows the pick-up PIN-code and QR code'
                defaultMessage='Your pick-up code'
            />
        ),
        YOUR_DROP_OFF_CODE: (
            <FormattedMessage
                id='Objects.PIN_CODE.YOUR_DROP_OFF_CODE'
                description='Title of the modal that shows the drop-off PIN-code and QR code'
                defaultMessage='Your drop-off code'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.PIN_CODE.PLURAL'
                description='Plural name for PIN-codes'
                defaultMessage='PIN-codes'
            />
        ),
        CODE: (
            <FormattedMessage
                id='Objects.PIN_CODE.CODE'
                description='Label for code'
                defaultMessage='Code'
            />
        ),
        CHALLENGE: (
            <FormattedMessage
                id='Objects.PIN_CODE.CHALLENGE'
                description='Label for PIN-code challenge'
                defaultMessage='Challenge'
            />
        ),
        NEVER_EXPIRES: (
            <FormattedMessage
                id='Objects.PIN_CODE.NEVER_EXPIRES'
                description='Label for PIN-code never expires'
                defaultMessage='Never expires'
            />
        ),
        EXPIRED: (
            <FormattedMessage
                id='Objects.PIN_CODE.EXPIRED'
                description='Label for PIN-code that is past its valid timestamp on transaction detail cards'
                defaultMessage='Expired'
            />
        ),
        EXPIRES_IN: (time: React.ReactNode) => (
            <FormattedMessage
                id='Objects.PIN_CODE.EXPIRES_IN'
                description='Label for PIN-code expires in'
                defaultMessage='Expires in {time}'
                values={{ time }}
            />
        ),
        NO_PIN_CODES: (
            <FormattedMessage
                id='Objects.PIN_CODE.NO_PIN_CODES'
                description='Label for no PIN-codes'
                defaultMessage='No PIN-codes available'
            />
        ),
        VALID_UNTIL: (
            <FormattedMessage
                id='Objects.PIN_CODE.VALID_UNTIL'
                description='Label for PIN-code valid until'
                defaultMessage='Valid until'
            />
        )
    },
    SUPPLIER: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.SUPPLIER.DEFAULT'
                description='Label for supplier'
                defaultMessage='Supplier'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.SUPPLIER.PLURAL'
                description='Plural name for suppliers'
                defaultMessage='Suppliers'
            />
        )
    },
    CONTACT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.CONTACT.DEFAULT'
                description='Label for contact'
                defaultMessage='Contact'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.CONTACT.PLURAL'
                description='Plural name for contacts'
                defaultMessage='Contacts'
            />
        )
    },
    CONTACT_GROUP: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.CONTACT_GROUP.DEFAULT'
                description='Label for contact group'
                defaultMessage='Contact group'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.CONTACT_GROUP.PLURAL'
                description='Plural name for contact groups'
                defaultMessage='Contact groups'
            />
        )
    },
    IMPORT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.IMPORT.DEFAULT'
                description='Label for import'
                defaultMessage='Import'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.IMPORT.PLURAL'
                description='Plural name for imports'
                defaultMessage='Imports'
            />
        )
    },
    STOCK: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.STOCK.DEFAULT'
                description='Label for stock'
                defaultMessage='Stock'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.STOCK.PLURAL'
                description='Plural name for stocks'
                defaultMessage='Stocks'
            />
        ),
        UPDATE: {
            DEFAULT: (
                <FormattedMessage
                    id='Objects.STOCK.UPDATE.DEFAULT'
                    description='Label for stock update'
                    defaultMessage='Stock update'
                />
            ),
            PLURAL: (
                <FormattedMessage
                    id='Objects.STOCK.UPDATE.PLURAL'
                    description='Plural name for stock updates'
                    defaultMessage='Stock updates'
                />
            )
        },
        AMOUNT_TO_FILL: (
            <FormattedMessage
                id='Objects.STOCK.AMOUNT_TO_FILL'
                defaultMessage='Amount to fill'
                description='Amount to fill'
            />
        ),
        CURRENT_STOCK: (
            <FormattedMessage
                id='vendingProductStockInfo.currentStock'
                defaultMessage='Current stock'
                description='Message displayed in the stock tab of product in vending'
            />
        ),
        MIN_STOCK: (
            <FormattedMessage
                id='Objects.STOCK.MIN_STOCK'
                defaultMessage='Min. stock'
                description='Header for min stock'
            />
        ),
        MAX_STOCK: (
            <FormattedMessage
                id='Objects.STOCK.MAX_STOCK'
                defaultMessage='Max. stock'
                description='Header for max stock'
            />
        ),
        IN_OTHER_SPOT: (
            <FormattedMessage
                id='Objects.STOCK.IN_OTHER_SPOT'
                defaultMessage='This product is available at another location'
                description='Message shown when product is out of stock in current spot but available in other spots'
            />
        )
    },
    UNKNOWN: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.UNKNOWN.DEFAULT'
                description='Label for unknown'
                defaultMessage='Unknown'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.UNKNOWN.PLURAL'
                description='Plural name for unknowns'
                defaultMessage='Unknowns'
            />
        )
    },
    PROBLEM: {
        POSSIBLE_PROBLEMS: (
            <FormattedMessage
                id='Objects.PROBLEM.POSSIBLE_PROBLEMS'
                description='Label for possible problems'
                defaultMessage='Possible problems'
            />
        ),
        DEFECT_LOG: (
            <FormattedMessage
                id='Objects.PROBLEM.DEFECT_LOG'
                description='Label for defect log'
                defaultMessage='Defect log'
            />
        ),
        REPORT_PROBLEM: (
            <FormattedMessage
                id='Objects.PROBLEM.REPORT_PROBLEM'
                description='Label for report problem'
                defaultMessage='Report problem'
            />
        ),
        DEFAULT: (
            <FormattedMessage
                id='Objects.PROBLEM.DEFAULT'
                description='Label for problem'
                defaultMessage='Problem'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.PROBLEM.PLURAL'
                description='Plural name for problems'
                defaultMessage='Problems'
            />
        ),
        NAME_HELP_MESSAGE: (
            <FormattedMessage
                id='Objects.PROBLEM.NAME_HELP_MESSAGE'
                description='Help message for problem name input field'
                defaultMessage='This name is only for internal use and should give a short description of the problem.'
            />
        ),
        NAME_PLACEHOLDER: (
            <FormattedMessage
                id='Objects.PROBLEM.NAME_PLACEHOLDER'
                description='Placeholder for problem name input field'
                defaultMessage='Broken glass'
            />
        ),
        REMARK: (
            <FormattedMessage
                id='Objects.PROBLEM.REMARK'
                description='Label for remark'
                defaultMessage='Remark'
            />
        )
    },
    DEVICE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.DEVICE.DEFAULT'
                description='Label for device'
                defaultMessage='Device'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.DEVICE.PLURAL'
                description='Plural name for devices'
                defaultMessage='Devices'
            />
        ),
        QR: (
            <FormattedMessage
                id='Objects.DEVICE.QR'
                description='Label for QR device'
                defaultMessage='QR'
            />
        ),
        BADGE: (
            <FormattedMessage
                id='Objects.DEVICE.BADGE'
                description='Label for Badge device'
                defaultMessage='Badge'
            />
        )
    },
    DRIVER: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.DRIVER.DEFAULT'
                description='Label for driver'
                defaultMessage='Driver'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.DRIVER.PLURAL'
                description='Plural name for drivers'
                defaultMessage='Drivers'
            />
        )
    },
    LOCKER: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.DEVICE.LOCKER.DEFAULT'
                description='Label for locker'
                defaultMessage='Locker'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.DEVICE.LOCKER.PLURAL'
                description='Plural name for lockers'
                defaultMessage='Lockers'
            />
        )
    },
    REQUIREMENT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.REQUIREMENT.DEFAULT'
                description='Label for requirement'
                defaultMessage='Requirement'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.REQUIREMENT.PLURAL'
                description='Plural name for requirements'
                defaultMessage='Requirements'
            />
        )
    },
    ENTITY_TYPE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.ENTITY_TYPE.DEFAULT'
                description='Label for entity type'
                defaultMessage='Entity type'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.ENTITY_TYPE.PLURAL'
                description='Plural name for entity types'
                defaultMessage='Entity types'
            />
        )
    },
    IOT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.IOT.DEFAULT'
                description='Label for IoT'
                defaultMessage='IOT'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.IOT.PLURAL'
                description='Plural name for IoTs'
                defaultMessage='IOTs'
            />
        ),
        VENDING_MACHINE: (
            <FormattedMessage
                id='Objects.IOT.VENDING_MACHINE'
                description='Label for vending machine'
                defaultMessage='Vending machine'
            />
        ),
        TWIN_IOT: (
            <FormattedMessage
                id='Objects.IOT.TWIN_IOT'
                description='Label for twin IoT'
                defaultMessage='Twin IOT'
            />
        ),
        ASSET: {
            DEFAULT: (
                <FormattedMessage
                    id='Objects.IOT.ASSET'
                    description='Label for asset'
                    defaultMessage='Asset'
                />
            ),
            PLURAL: (
                <FormattedMessage
                    id='Objects.IOT.ASSET.PLURAL'
                    description='Plural name for assets'
                    defaultMessage='Assets'
                />
            )
        },
        ASSET_NAME: (
            <FormattedMessage
                id='Objects.IOT.ASSET_NAME'
                description='Label for asset name'
                defaultMessage='Asset name'
            />
        )
    },
    SETTING: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.SETTING.DEFAULT'
                description='Label for setting'
                defaultMessage='Setting'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.SETTING.PLURAL'
                description='Plural name for settings'
                defaultMessage='Settings'
            />
        )
    },
    EQUIPMENT_PROBLEM: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.EQUIPMENT_PROBLEM.DEFAULT'
                description='Label for equipment problem'
                defaultMessage='Equipment problem'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.EQUIPMENT_PROBLEM.PLURAL'
                description='Plural name for equipment problems'
                defaultMessage='Equipment problems'
            />
        ),
        PROBLEM: (
            <FormattedMessage
                id='Objects.EQUIPMENT_PROBLEM.PROBLEM'
                description='Label for problem'
                defaultMessage='Problem'
            />
        )
    },
    IDENTIFICATION: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.IDENTIFICATION.DEFAULT'
                description='Label for identification'
                defaultMessage='Identification'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.IDENTIFICATION.PLURAL'
                description='Plural name for identifications'
                defaultMessage='Identifications'
            />
        ),
        SECRET: (
            <FormattedMessage
                id='Objects.IDENTIFICATION.SECRET'
                description='Label for secret'
                defaultMessage='Secret'
            />
        ),
        INDEFINITELY: (
            <FormattedMessage
                id='Objects.IDENTIFICATION.INDEFINITELY'
                description='Label for indefinitely'
                defaultMessage='Indefinitely'
            />
        ),
        PENDING_LINK_MESSAGE: PendingLinkMessage,
        SUCCESS_LINK_MESSAGE: SuccessLinkMessage,
        ERROR_LINK_MESSAGE: ErrorLinkMessage,
        PENDING_UNLINK_MESSAGE: PendingUnlinkMessage,
        SUCCESS_UNLINK_MESSAGE: SuccessUnlinkMessage,
        ERROR_UNLINK_MESSAGE: ErrorUnlinkMessage,
        BASIC_AUTH: (
            <FormattedMessage
                id='Objects.IDENTIFICATION.BASIC_AUTH'
                description='Label for basic auth'
                defaultMessage='Basic auth'
            />
        ),
        PASSWORD: (
            <FormattedMessage
                id='Objects.IDENTIFICATION.PASSWORD'
                description='Label for password'
                defaultMessage='Password'
            />
        ),
        BADGE: (
            <FormattedMessage
                id='Objects.IDENTIFICATION.BADGE'
                description='Label for badge'
                defaultMessage='Badge'
            />
        ),
        API_KEY: (
            <FormattedMessage
                id='Objects.IDENTIFICATION.API_KEY'
                description='Label for API key'
                defaultMessage='API key'
            />
        )
    },
    MEDIA_FILE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.MEDIA_FILE.DEFAULT'
                description='Label for media file'
                defaultMessage='Media file'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.MEDIA_FILE.PLURAL'
                description='Plural name for media files'
                defaultMessage='Media files'
            />
        ),
        FILE: (
            <FormattedMessage
                id='Objects.MEDIA_FILE.FILE'
                description='Label for file'
                defaultMessage='File'
            />
        ),
        FILE_TYPE: (
            <FormattedMessage
                id='Objects.MEDIA_FILE.TYPE'
                description='Label for type'
                defaultMessage='File type'
            />
        ),
        SIZE: (
            <FormattedMessage
                id='Objects.MEDIA_FILE.SIZE'
                description='Label for file size'
                defaultMessage='File size'
            />
        )
    },
    QUESTION_GROUP: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.QUESTION_GROUP.DEFAULT'
                description='Label for question group'
                defaultMessage='Question group'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.QUESTION_GROUP.PLURAL'
                description='Plural name for question group'
                defaultMessage='Questionnaires'
            />
        )
    },
    QUESTION: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.QUESTION.DEFAULT'
                description='Label for question'
                defaultMessage='Question'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.QUESTION.PLURAL'
                description='Plural name for questions'
                defaultMessage='Questions'
            />
        ),
        IMAGE_OR_VIDEO: (
            <FormattedMessage
                id='Objects.QUESTION.IMAGE_OR_VIDEO'
                description='Label for image or video'
                defaultMessage='Image/Video'
            />
        ),
        DURATION: (
            <FormattedMessage
                id='Objects.QUESTION.DURATION'
                description='Label for duration'
                defaultMessage='Duration'
            />
        )
    },
    ANSWER: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.ANSWER.DEFAULT'
                description='Label for answer'
                defaultMessage='Answer'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.ANSWER.PLURAL'
                description='Plural name for answers'
                defaultMessage='Answers'
            />
        ),
        ILLUSTRATION: (
            <FormattedMessage
                id='Objects.ANSWER.ILLUSTRATION'
                description='Label for illustration'
                defaultMessage='Illustration'
            />
        ),
        SORTING: (
            <FormattedMessage
                id='Objects.ANSWER.SORTING'
                description='Label for sorting'
                defaultMessage='Sorting'
            />
        ),
        RESULT: (
            <FormattedMessage
                id='Objects.ANSWER.RESULT'
                description='Label for result'
                defaultMessage='Result'
            />
        ),
        VIDEO: (
            <FormattedMessage
                id='Objects.ANSWER.VIDEO'
                description='Label for video'
                defaultMessage='Video'
            />
        ),
        IMAGE_OR_VIDEO: (
            <FormattedMessage
                id='Objects.ANSWER.IMAGE_OR_VIDEO'
                description='Label for image or video'
                defaultMessage='Image/Video'
            />
        )
    },
    TAG: {
        TAG: (
            <FormattedMessage
                id='Objects.TAG.TAG'
                description='Label for tag'
                defaultMessage='Tag'
            />
        ),
        DEFAULT: (
            <FormattedMessage
                id='Objects.TAG.DEFAULT'
                description='Label for Tag'
                defaultMessage='Tag'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.TAG.PLURAL'
                description='Plural name for Tags'
                defaultMessage='Tags'
            />
        )
    },
    TIMER: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.TIMER.DEFAULT'
                description='Label for a timer entity'
                defaultMessage='Timer'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.TIMER.PLURAL'
                description='Plural name for timer entities'
                defaultMessage='Timers'
            />
        ),
        START: (start: React.ReactNode) => (
            <FormattedMessage
                id='Objects.TIMER.START'
                description='Read-only start timestamp on timer update forms (API does not allow patching start)'
                defaultMessage='Start: {start}'
                values={{ start }}
            />
        )
    },
    ENTITY_SHARE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.ENTITY_SHARE.DEFAULT'
                description='Label for a cross-account entity share'
                defaultMessage='Entity share'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.ENTITY_SHARE.PLURAL'
                description='Plural name for cross-account entity shares'
                defaultMessage='Entity shares'
            />
        )
    },
    ROLE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.ROLE.DEFAULT'
                description='Label for role'
                defaultMessage='Role'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.ROLE.PLURAL'
                description='Plural name for roles'
                defaultMessage='Roles'
            />
        ),
        VIEW_PERMISSIONS: (
            <FormattedMessage
                id='Objects.ROLE.VIEW_PERMISSIONS'
                defaultMessage='View permissions'
            />
        ),
        CONTEXT: (
            <FormattedMessage
                id='Objects.ROLE.CONTEXT'
                defaultMessage='Context'
            />
        ),
        USE_PREDEFINED: (
            <FormattedMessage
                id='Objects.ROLE.USE_PREDEFINED'
                defaultMessage='Use predefined'
            />
        )
    },
    CUSTOM_ROLE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.CUSTOM_ROLE.DEFAULT'
                description='Label for custom role'
                defaultMessage='Custom role'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.CUSTOM_ROLE.PLURAL'
                description='Plural name for custom roles'
                defaultMessage='Custom roles'
            />
        )
    },
    PREDEFINED_ROLE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.PREDEFINED_ROLE.DEFAULT'
                description='Label for predefined role'
                defaultMessage='Predefined role'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.PREDEFINED_ROLE.PLURAL'
                description='Plural name for predefined roles'
                defaultMessage='Predefined roles'
            />
        )
    },
    EQUIPMENT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.EQUIPMENT.DEFAULT'
                description='Label for equipment'
                defaultMessage='Equipment'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.EQUIPMENT.PLURAL'
                description='Plural name for equipment'
                defaultMessage='Equipments'
            />
        ),
        SERIAL_NUMBER: (
            <FormattedMessage
                id='Objects.EQUIPMENT.SERIAL_NUMBER'
                description='Label for serial number'
                defaultMessage='Serial number'
            />
        ),
        SN: (
            <FormattedMessage
                id='Objects.EQUIPMENT.SN'
                description='Label for serial number abreviation'
                defaultMessage='SN'
            />
        ),
        EQUIPMENT_SN: (
            <FormattedMessage
                id='Objects.EQUIPMENT.EQUIPMENT_SN'
                description='Label for equipment serial number abreviation'
                defaultMessage='Equipment SN'
            />
        ),
        LINKED_EQUIPMENT: (
            <FormattedMessage
                id='Objects.EQUIPMENT.LINKED_EQUIPMENT'
                description='Label for linked equipment'
                defaultMessage='Linked equipment'
            />
        ),
        STATUS: (
            <FormattedMessage
                id='Objects.EQUIPMENT.STATUS'
                description='Label for equipment status'
                defaultMessage='Equipment status'
            />
        ),
        PRODUCT: (
            <FormattedMessage
                id='Objects.EQUIPMENT.PRODUCT'
                description='Label for equipment product'
                defaultMessage='Equipment product'
            />
        ),
        USE: {
            DEFAULT: (
                <FormattedMessage
                    id='Objects.EQUIPMENT.USE.DEFAULT'
                    description='Label for equipment use'
                    defaultMessage='Equipment use'
                />
            )
        },
        TAG: (
            <FormattedMessage
                id='Objects.EQUIPMENT.TAG'
                description='Label for equipment tag'
                defaultMessage='Equipment tag'
            />
        )
    },
    EQUIPMENT_GROUP: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.EQUIPMENT_GROUP.DEFAULT'
                description='Label for equipment group'
                defaultMessage='Equipment group'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.EQUIPMENT_GROUP.PLURAL'
                description='Plural name for equipment group'
                defaultMessage='Equipment groups'
            />
        )
    },
    ROLE_PERMISSION: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.ROLE_PERMISSION.DEFAULT'
                description='Label for role permission'
                defaultMessage='Role permission'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.ROLE_PERMISSION.PLURAL'
                description='Plural name for role permissions'
                defaultMessage='Role permissions'
            />
        ),
        RIGHT: (
            <FormattedMessage
                id='Objects.ROLE_PERMISSION.RIGHT'
                description='Label for right'
                defaultMessage='Right'
            />
        )
    },
    PERMISSION: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.PERMISSION.DEFAULT'
                description='Label for permission'
                defaultMessage='Permission'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.PERMISSION.PLURAL'
                description='Plural name for permissions'
                defaultMessage='Permissions'
            />
        )
    },
    PLAYLIST_ITEM: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.PLAYLIST_ITEM.DEFAULT'
                description='Label for playlist item'
                defaultMessage='Playlist item'
            />
        ),
        SORT_ORDER: (
            <FormattedMessage
                id='Objects.PLAYLIST_ITEM.SORT_ORDER'
                description='Order play list items are sorted'
                defaultMessage='Sort order'
            />
        ),
        DURATION: (
            <FormattedMessage
                id='Objects.PLAYLIST_ITEM.DURATION'
                description='Duration of an image or a video appearance'
                defaultMessage='Duration'
            />
        ),
        VISIBLE: (
            <FormattedMessage
                id='Objects.PLAYLIST_ITEM.VISIBLE'
                description='Label for visibility'
                defaultMessage='Visibility'
            />
        )
    },
    PLAYLIST: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.PLAYLIST.DEFAULT'
                description='Label for playlist'
                defaultMessage='Playlist'
            />
        )
    },
    COURIER: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.COURIER.DEFAULT'
                description='Label for courier'
                defaultMessage='Courier'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.COURIER.PLURAL'
                description='Label for couriers'
                defaultMessage='Couriers'
            />
        )
    },
    DOCUMENT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.DOCUMENT.DEFAULT'
                description='Label for document'
                defaultMessage='Document'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.DOCUMENT.PLURAL'
                description='Plural name for documents'
                defaultMessage='Documents'
            />
        ),
        IMAGE: (
            <FormattedMessage
                id='Objects.DOCUMENT.IMAGE'
                description='Label for image'
                defaultMessage='Image'
            />
        ),
        VIDEO: (
            <FormattedMessage
                id='Objects.DOCUMENT.VIDEO'
                description='Label for video'
                defaultMessage='Video'
            />
        ),
        MEDIA_FILES: (
            <FormattedMessage
                id='Objects.DOCUMENT.MEDIA_FILES'
                description='Label for media files'
                defaultMessage='Media files'
            />
        )
    },
    BUDGET: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.BUDGET.DEFAULT'
                description='Label for budget'
                defaultMessage='Budget'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.BUDGET.PLURAL'
                description='Plural name for budgets'
                defaultMessage='Budgets'
            />
        ),
        FROM_TIMESTAMP: (
            <FormattedMessage
                id='Objects.BUDGET.FROM_TIMESTAMP'
                description='Label for from timestamp'
                defaultMessage='From'
            />
        ),
        TO_TIMESTAMP: (
            <FormattedMessage
                id='Objects.BUDGET.TO_TIMESTAMP'
                description='Label for to timestamp'
                defaultMessage='To'
            />
        )
    },
    BUDGET_RULE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.BUDGET_RULE.DEFAULT'
                description='Label for budget rule'
                defaultMessage='Budget rule'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.BUDGET_RULE.PLURAL'
                description='Plural name for budget rules'
                defaultMessage='Budget rules'
            />
        )
    },
    TRANSACTION_RULE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.TRANSACTION_RULE.DEFAULT'
                description='Label for transaction rule'
                defaultMessage='Transaction rule'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.TRANSACTION_RULE.PLURAL'
                description='Plural name for transaction rules'
                defaultMessage='Transaction rules'
            />
        )
    },
    BUDGET_USE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.BUDGET_USE.DEFAULT'
                description='Label for budget use'
                defaultMessage='Budget use'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.BUDGET_USE.PLURAL'
                description='Plural name for budget uses'
                defaultMessage='Budget uses'
            />
        )
    },
    BUNDLE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.BUNDLE.DEFAULT'
                description='Label for bundle'
                defaultMessage='Bundle'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.BUNDLE.PLURAL'
                description='Plural name for bundles'
                defaultMessage='Bundles'
            />
        ),
        CONFLICT: (
            <FormattedMessage
                id='Objects.BUNDLE.CONFLICT'
                description='Toast when creating a bundle that already exists for the same account, application and timeframe'
                defaultMessage='A bundle with this application and timeframe already exists'
            />
        )
    },
    USE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.USE.DEFAULT'
                description='Label for use'
                defaultMessage='Use'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.USE.PLURAL'
                description='Plural name for uses'
                defaultMessage='Uses'
            />
        )
    },
    GROUP: {
        PLURAL: (
            <FormattedMessage
                id='Objects.GROUP.PLURAL'
                description='Plural name for groups'
                defaultMessage='Groups'
            />
        ),
        DEFAULT: (
            <FormattedMessage
                id='Objects.GROUP.DEFAULT'
                description='Label for group'
                defaultMessage='Group'
            />
        )
    },
    GROUP_MEMBER: {
        PLURAL: (
            <FormattedMessage
                id='Objects.GROUP_MEMBER.PLURAL'
                description='Plural name for group members'
                defaultMessage='Group members'
            />
        ),
        ADD: groupMemberAdd,
        PARENT: {
            DEFAULT: (
                <FormattedMessage
                    id='Objects.GROUP_MEMBER.PARENT'
                    description='Label for parent'
                    defaultMessage='Parent'
                />
            ),
            PLURAL: (
                <FormattedMessage
                    id='Objects.GROUP_MEMBER.PARENT_PLURAL'
                    description='Plural name for parents'
                    defaultMessage='Parents'
                />
            )
        }
    },
    RAKINDA: {
        MAC_ADDRESS: (
            <FormattedMessage
                id='Objects.RAKINDA.MAC_ADDRESS'
                description='Label for mac address'
                defaultMessage='Mac address'
            />
        ),
        STATUS: (
            <FormattedMessage
                id='Objects.RAKINDA.STATUS'
                description='Label for status'
                defaultMessage='Status'
            />
        ),
        HEARTBEAT: (
            <FormattedMessage
                id='Objects.RAKINDA.HEARTBEAT'
                description='Label for heartbeat'
                defaultMessage='Heartbeat'
            />
        ),
        MASTER_PIN_CODE: (
            <FormattedMessage
                id='Forms.MASTER_PIN_CODE'
                description='Label for master PIN-code'
                defaultMessage='Master PIN-code'
            />
        )
    },
    SLOT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.SLOT.DEFAULT'
                description='Label for slot'
                defaultMessage='SLOT'
            />
        ),
        DESTINATION: (
            <FormattedMessage
                id='Objects.SLOT.DESTINATION'
                description='Filter label for the destination SLOT of a parcel or transaction'
                defaultMessage='Destination SLOT'
            />
        ),
        SLOTS: (
            <FormattedMessage
                id='Objects.SLOT.SLOTS'
                description='Message for SLOTs'
                defaultMessage='SLOTs'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.SLOT.PLURAL'
                description='Plural name for slots'
                defaultMessage='SLOTs'
            />
        ),
        TEMPLATE: (
            <FormattedMessage
                id='Objects.SLOT.TEMPLATE'
                description='Label for slot template'
                defaultMessage='SLOT template'
            />
        ),
        TEMPLATE_PLURAL: (
            <FormattedMessage
                id='Objects.SLOT.TEMPLATE_PLURAL'
                description='Plural name for slot templates'
                defaultMessage='SLOT templates'
            />
        ),
        NOTE: (
            <FormattedMessage
                id='Objects.SLOT.NOTE'
                description='Label for note'
                defaultMessage='Note'
            />
        ),
        DISPLAY: (
            <FormattedMessage
                id='Objects.SLOT.DISPLAY'
                description='Label for display'
                defaultMessage='Display'
            />
        ),
        DROP_STATION_SLOT: (
            <FormattedMessage
                id='Objects.SLOT.DROP_STATION_SLOT'
                description='Label for drop station slot'
                defaultMessage='Drop station SLOT'
            />
        ),
        DROP_OFF_OPENING: (
            <FormattedMessage
                id='Objects.SLOT.DROP_OFF_OPENING'
                description='Role label on the drop opening of a drop station in the SPOT layout'
                defaultMessage='Drop off here'
            />
        ),
        ROW: {
            DEFAULT: (
                <FormattedMessage
                    id='Objects.SLOT.ROW'
                    description='Label for row'
                    defaultMessage='Row'
                />
            ),
            PLURAL: (
                <FormattedMessage
                    id='Objects.SLOT.ROW_PLURAL'
                    description='Plural name for rows'
                    defaultMessage='Rows'
                />
            )
        },
        COLUMN: {
            DEFAULT: (
                <FormattedMessage
                    id='Objects.SLOT.COLUMN'
                    description='Label for column'
                    defaultMessage='Column'
                />
            ),
            PLURAL: (
                <FormattedMessage
                    id='Objects.SLOT.COLUMN_PLURAL'
                    description='Plural name for columns'
                    defaultMessage='Columns'
                />
            )
        },
        STATUS: {
            DEFAULT: (
                <FormattedMessage
                    id='Objects.SLOT.STATUS'
                    description='Label for status'
                    defaultMessage='Status'
                />
            ),
            BROKEN: (
                <FormattedMessage
                    id='Objects.SLOT.STATUS.BROKEN'
                    description='Label for broken status'
                    defaultMessage='Broken'
                />
            ),
            AVAILABLE: (
                <FormattedMessage
                    id='Objects.SLOT.STATUS.AVAILABLE'
                    description='Label for available status'
                    defaultMessage='Available'
                />
            ),
            OPENING: (
                <FormattedMessage
                    id='Objects.SLOT.STATUS.OPENING'
                    description='Label for opening status'
                    defaultMessage='Opening'
                />
            ),
            OPEN: (
                <FormattedMessage
                    id='Objects.SLOT.STATUS.OPEN'
                    description='Label for open status'
                    defaultMessage='Open'
                />
            ),
            STILL_OPEN: (
                <FormattedMessage
                    id='Objects.SLOT.STATUS.STILL_OPEN'
                    description='Label for still open status'
                    defaultMessage='Still open'
                />
            ),
            CLOSED: (
                <FormattedMessage
                    id='Objects.SLOT.STATUS.CLOSED'
                    description='Label for closed status'
                    defaultMessage='Closed'
                />
            ),
            NOT_CLOSED: (
                <FormattedMessage
                    id='Objects.SLOT.STATUS.NOT_CLOSED'
                    description='Label for not closed status'
                    defaultMessage='Not closed'
                />
            ),
            NOT_OPENED: (
                <FormattedMessage
                    id='Objects.SLOT.STATUS.NOT_OPENED'
                    description='Label for not opened status'
                    defaultMessage='Not opened'
                />
            )
        },
        PENDING_OPENING_MESSAGE: PendingOpeningMessage,
        SUCCESS_OPENING_MESSAGE: SuccessOpeningMessage,
        ERROR_OPENING_MESSAGE: ErrorOpeningMessage
    },
    DIMENSION: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.DIMENSION.DEFAULT'
                description='Label for dimension'
                defaultMessage='Dimension'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.DIMENSION.PLURAL'
                description='Plural name for dimensions'
                defaultMessage='Dimensions'
            />
        ),
        DEPTH: (
            <FormattedMessage
                id='Objects.DIMENSION.DEPTH'
                description='Label for depth'
                defaultMessage='Depth'
            />
        ),
        WIDTH: (
            <FormattedMessage
                id='Objects.DIMENSION.WIDTH'
                description='Label for width'
                defaultMessage='Width'
            />
        ),
        HEIGHT: (
            <FormattedMessage
                id='Objects.DIMENSION.HEIGHT'
                description='Label for height'
                defaultMessage='Height'
            />
        )
    },
    BADGE: {
        NUMBER: (
            <FormattedMessage
                id='Objects.BADGE.NUMBER'
                description='Label for number'
                defaultMessage='Number'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.BADGE.PLURAL'
                description='Plural name for badges'
                defaultMessage='Badges'
            />
        ),
        DEFAULT: (
            <FormattedMessage
                id='Objects.BADGE.DEFAULT'
                description='Label for badge'
                defaultMessage='Badge'
            />
        ),
        USER_BADGE: {
            DEFAULT: (
                <FormattedMessage
                    id='Objects.BADGE.USER_BADGE.DEFAULT'
                    description='Label for user badge'
                    defaultMessage='User badge'
                />
            ),
            PLURAL: (
                <FormattedMessage
                    id='Objects.BADGE.USER_BADGE.PLURAL'
                    description='Plural name for user badges'
                    defaultMessage='User badges'
                />
            )
        }
    },
    CATALOG: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.CATALOG.DEFAULT'
                description='Label for catalog'
                defaultMessage='Catalog'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.CATALOG.PLURAL'
                description='Plural name for catalogs'
                defaultMessage='Catalogs'
            />
        )
    },
    HIERARCHY: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.HIERARCHY.DEFAULT'
                description='Label for hierarchy'
                defaultMessage='Hierarchy'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.HIERARCHY.PLURAL'
                description='Plural name for hierarchies'
                defaultMessage='Hierarchies'
            />
        )
    },
    CATEGORY: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.CATEGORY.DEFAULT'
                description='Label for category'
                defaultMessage='Category'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.CATEGORY.PLURAL'
                description='Plural name for categories'
                defaultMessage='Categories'
            />
        ),
        CATEGORY_NAME: (
            <FormattedMessage
                id='Objects.CATEGORY.NAME'
                description='label for categories name'
                defaultMessage='Category name'
            />
        ),
        PARENT_CATEGORY: (
            <FormattedMessage
                id='Objects.CATEGORY.PARENT_CATEGORY'
                description='Label for parent category'
                defaultMessage='Parent category'
            />
        ),
        MAIN_CATEGORY: (
            <FormattedMessage
                id='Objects.CATEGORY.MAIN_CATEGORY'
                description='Label for main category'
                defaultMessage='Main category'
            />
        ),
        SUB_CATEGORY: (
            <FormattedMessage
                id='Objects.CATEGORY.SUB_CATEGORY'
                description='Label for subcategory'
                defaultMessage='Subcategory'
            />
        ),
        SUB_CATEGORIES: (
            <FormattedMessage
                id='Objects.CATEGORY.SUB_CATEGORIES'
                description='Label for subcategories'
                defaultMessage='Subcategories'
            />
        )
    },
    ATTRIBUTE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.ATTRIBUTE.DEFAULT'
                description='Label for attribute'
                defaultMessage='Attribute'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.ATTRIBUTE.PLURAL'
                description='Plural name for attributes'
                defaultMessage='Attributes'
            />
        ),
        CHOICES: (
            <FormattedMessage
                id='Objects.ATTRIBUTE.CHOICES'
                description='Plural name for attribute choices'
                defaultMessage='Choices'
            />
        ),
        ATTRIBUTE_NAME: (
            <FormattedMessage
                id='Objects.ATTRIBUTE.NAME'
                description='label for attribute name'
                defaultMessage='Attribute name'
            />
        )
    },
    ATTRIBUTE_VALUE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.ATTRIBUTE_VALUE.DEFAULT'
                description='Label for attribute value'
                defaultMessage='Attribute value'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.ATTRIBUTE_VALUE.PLURAL'
                description='Plural name for attribute values'
                defaultMessage='Attribute values'
            />
        ),
        VALUE: (
            <FormattedMessage
                id='Objects.ATTRIBUTE_VALUE.VALUE'
                description='Label for value'
                defaultMessage='Value'
            />
        )
    },
    PRODUCT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.PRODUCTS.DEFAULT'
                description='Label for products'
                defaultMessage='Product'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.PRODUCTS.PLURAL'
                description='Plural name for products'
                defaultMessage='Products'
            />
        ),
        PRODUCT_NAME: (
            <FormattedMessage
                id='Objects.PRODUCTS.NAME'
                description='label for product name'
                defaultMessage='Product name'
            />
        ),
        PRODUCT_DESCRIPTION: (
            <FormattedMessage
                id='Objects.PRODUCTS.DESCRIPTION'
                description='label for product description'
                defaultMessage='Product description'
            />
        ),
        USER_INFO: (
            <FormattedMessage
                id='Objects.PRODUCTS.USER_INFO'
                description='Label for user info'
                defaultMessage='User info'
            />
        ),
        EAN: (
            <FormattedMessage
                id='Objects.PRODUCTS.EAN'
                description='Label for EAN'
                defaultMessage='EAN'
            />
        ),
        SKU: (
            <FormattedMessage
                id='Objects.PRODUCTS.SKU'
                description='Label for SKU'
                defaultMessage='SKU'
            />
        ),
        SUPPLIER: (
            <FormattedMessage
                id='Objects.PRODUCTS.SUPPLIER'
                description='Label for supplier'
                defaultMessage='Supplier'
            />
        ),
        OWNER: (
            <FormattedMessage
                id='Objects.PRODUCTS.OWNER'
                description='Label for owner'
                defaultMessage='Owner'
            />
        ),
        OWNERS: (
            <FormattedMessage
                id='Objects.PRODUCTS.OWNERS'
                description='Label for owners'
                defaultMessage='Owners'
            />
        ),
        EQUIPMENT_TYPE: (
            <FormattedMessage
                id='Objects.PRODUCTS.EQUIPMENT_TYPE'
                description='Label for equipment type'
                defaultMessage='Equipment type'
            />
        ),
        PRODUCT_TYPE: (
            <FormattedMessage
                id='Objects.PRODUCTS.PRODUCT_TYPE'
                description='Label for product type'
                defaultMessage='Product type'
            />
        ),
        KIT: (
            <FormattedMessage
                id='Objects.PRODUCTS.KIT'
                description='Label for kit'
                defaultMessage='Kit'
            />
        )
    },
    CONSUMPTION: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.CONSUMPTION.DEFAULT'
                description='Label for consumption'
                defaultMessage='Consumption'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.CONSUMPTION.PLURAL'
                description='Plural name for consumptions'
                defaultMessage='Consumptions'
            />
        )
    },
    CONSUMABLE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.CONSUMABLE.DEFAULT'
                description='Label for consumable'
                defaultMessage='Consumable'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.CONSUMABLE.PLURAL'
                description='Plural name for consumables'
                defaultMessage='Consumables'
            />
        )
    },
    PRODUCT_KIT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.PRODUCT_KIT.DEFAULT'
                description='Label for product kit'
                defaultMessage='Product kit'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.PRODUCT_KIT.PLURAL'
                description='Plural name for product kits'
                defaultMessage='Product kits'
            />
        )
    },
    SERVICE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.SERVICE.DEFAULT'
                description='Label for service'
                defaultMessage='Service'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.SERVICE.PLURAL'
                description='Plural name for services'
                defaultMessage='Services'
            />
        )
    },
    REUSABLE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.REUSABLE.DEFAULT'
                description='Label for reusable'
                defaultMessage='Reusable'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.REUSABLE.PLURAL'
                description='Plural name for reusables'
                defaultMessage='Reusables'
            />
        )
    },
    PRODUCT_GROUP: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.PRODUCT_GROUP.DEFAULT'
                description='Label for product group'
                defaultMessage='Product group'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.PRODUCT_GROUP.PLURAL'
                description='Plural name for product groups'
                defaultMessage='Product groups'
            />
        )
    },
    PRODUCT_CATEGORY: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.PRODUCT_CATEGORY.DEFAULT'
                description='Label for product category'
                defaultMessage='Product category'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.PRODUCT_CATEGORY.PLURAL'
                description='Plural name for product categories'
                defaultMessage='Product categories'
            />
        )
    },
    USER_GROUP: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.USER_GROUP.DEFAULT'
                description='Label for user group'
                defaultMessage='User group'
            />
        ),
        MEMBERS_COUNT: (
            <FormattedMessage
                id='Objects.USER_GROUP.MEMBERS_COUNT'
                description='Label for user group members count'
                defaultMessage='# members'
            />
        ),
        GROUP_NAME: (
            <FormattedMessage
                id='Objects.USER_GROUP.NAME'
                description='Label for user group name'
                defaultMessage='Group name'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.USER_GROUP.PLURAL'
                description='Plural name for user groups'
                defaultMessage='User groups'
            />
        )
    },
    DEVICE_GROUP: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.DEVICE_GROUP.DEFAULT'
                description='Label for device group'
                defaultMessage='Device group'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.DEVICE_GROUP.PLURAL'
                description='Plural name for device groups'
                defaultMessage='Device groups'
            />
        )
    },
    USER_INTERFACE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.USER_INTERFACE.DEFAULT'
                description='Label for user interface'
                defaultMessage='User interface'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.USER_INTERFACE.PLURAL'
                description='Plural name for user interfaces'
                defaultMessage='User interfaces'
            />
        )
    },
    USER_INTERFACE_BUTTON: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.USER_INTERFACE_BUTTON.DEFAULT'
                description='Label for user interface button'
                defaultMessage='User interface button'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.USER_INTERFACE_BUTTON.PLURAL'
                description='Plural name for user interface buttons'
                defaultMessage='User interface buttons'
            />
        )
    },
    WORKFLOW: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.WORKFLOW.DEFAULT'
                description='Label for workflow'
                defaultMessage='Workflow'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.WORKFLOW.PLURAL'
                description='Plural name for workflows'
                defaultMessage='Workflows'
            />
        ),
        CHANGE_STATE: (
            <FormattedMessage
                id='Objects.WORKFLOW.STATE'
                description='Label for change state'
                defaultMessage='Change state'
            />
        )
    },
    WORKFLOW_STEP: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.WORKFLOW_STEP.DEFAULT'
                description='Label for workflow step'
                defaultMessage='Workflow step'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.WORKFLOW_STEP.PLURAL'
                description='Plural name for workflow steps'
                defaultMessage='Workflow steps'
            />
        )
    },
    ACCOUNT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.ACCOUNT.DEFAULT'
                description='Label for account'
                defaultMessage='Account'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.ACCOUNT.PLURAL'
                description='Plural name for accounts'
                defaultMessage='Accounts'
            />
        ),
        BRANDING: (
            <FormattedMessage
                id='Objects.ACCOUNT.BRANDING'
                description='Label for branding'
                defaultMessage='Branding'
            />
        ),
        OTHER_ACCOUNT: (
            <FormattedMessage
                id='Objects.ACCOUNT.OTHER_ACCOUNT'
                description='Tooltip for the share marker on an entity that belongs to another account'
                defaultMessage='Other account'
            />
        )
    },
    BRANDING: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.BRANDING.DEFAULT'
                description='Label for branding'
                defaultMessage='Branding'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.BRANDING.PLURAL'
                description='Plural name for brandings'
                defaultMessage='Brandings'
            />
        )
    },
    LOGO: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.LOGO.DEFAULT'
                description='Label for logo'
                defaultMessage='Logo'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.LOGO.PLURAL'
                description='Plural name for logos'
                defaultMessage='Logos'
            />
        )
    },
    WIZARD: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.WIZARD.DEFAULT'
                description='Label for wizard'
                defaultMessage='Wizard'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.WIZARD.PLURAL'
                description='Plural name for wizards'
                defaultMessage='Wizards'
            />
        )
    },
    COMMON_FIELDS: {
        VALID_FROM: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.VALID_FROM'
                description='Label for valid from'
                defaultMessage='Valid from'
            />
        ),
        VALID_TO: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.VALID_TO'
                description='Label for valid to'
                defaultMessage='Valid to'
            />
        ),
        LOCATION: {
            DEFAULT: (
                <FormattedMessage
                    id='Objects.MODULE.LOCATION'
                    description='Label for location'
                    defaultMessage='Location'
                />
            ),
            PLURAL: (
                <FormattedMessage
                    id='Objects.COMMON_FIELDS.LOCATION.PLURAL'
                    description='Plural name for locations'
                    defaultMessage='Locations'
                />
            )
        },
        AMOUNT: (
            <FormattedMessage
                key='consumptions.amount'
                id='consumptions.amount'
                defaultMessage='Amount'
            />
        ),
        ENABLED: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.ENABLED'
                description='Label for enabled'
                defaultMessage='Enabled'
            />
        ),
        DISABLED: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.DISABLED'
                description='Label for disabled'
                defaultMessage='Disabled'
            />
        ),
        UPDATED_AT: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.UPDATED_AT'
                description='Label for updated date'
                defaultMessage='Updated'
            />
        ),
        CREATED_AT: (
            <FormattedMessage
                id='Objects.TRANSACTION.CREATED_AT'
                description='Label for transaction creation date'
                defaultMessage='Created'
            />
        ),
        SINCE: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.SINCE'
                description='Label for since'
                defaultMessage='Since'
            />
        ),
        BEFORE: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.BEFORE'
                description='Label for before'
                defaultMessage='Before'
            />
        ),
        AFTER: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.AFTER'
                description='Label for after'
                defaultMessage='After'
            />
        ),
        MODE: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.MODE'
                description='Label for mode'
                defaultMessage='Mode'
            />
        ),
        NAME: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.NAME'
                description='Label for name'
                defaultMessage='Name'
            />
        ),
        DESCRIPTION: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.DESCRIPTION'
                description='Label for description'
                defaultMessage='Description'
            />
        ),
        TYPE: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.TYPE'
                description='Label for type'
                defaultMessage='Type'
            />
        ),
        STATUS: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.STATUS'
                description='Label for status'
                defaultMessage='Status'
            />
        ),
        KEY: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.KEY'
                description='Label for key'
                defaultMessage='Key'
            />
        ),
        INDEX: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.INDEX'
                description='Label for index'
                defaultMessage='Index'
            />
        ),
        BRAND: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.BRAND'
                description='Label for brand'
                defaultMessage='Brand'
            />
        ),
        PROTOCOL: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.PROTOCOL'
                description='Label for protocol'
                defaultMessage='Protocol'
            />
        ),
        STATE: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.STATE'
                description='Label for state'
                defaultMessage='State'
            />
        ),
        ITEM: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.ITEM'
                description='Label for item'
                defaultMessage='Item'
            />
        ),
        TARGET: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.TARGET'
                description='Label for target'
                defaultMessage='Target'
            />
        ),
        SIZE: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.SIZE'
                description='Label for size'
                defaultMessage='Size'
            />
        ),
        FORMAT: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.FORMAT'
                description='Label for format'
                defaultMessage='Format'
            />
        ),
        COLOR: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.COLOR'
                description='Label for color'
                defaultMessage='Color'
            />
        ),
        TARGET_TYPE: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.TARGET_TYPE'
                description='Label for target type'
                defaultMessage='Target type'
            />
        ),
        IDENTIFIER: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.IDENTIFIER'
                description='Label for identifier'
                defaultMessage='Identifier'
            />
        ),
        ORDER: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.ORDER'
                description='Label for order'
                defaultMessage='Order'
            />
        ),
        PICTURES: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.PICTURES'
                description='Label for pictures'
                defaultMessage='Pictures'
            />
        ),
        PICTURE: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.PICTURE'
                description='Label for picture'
                defaultMessage='Picture'
            />
        ),
        QUANTITY: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.QUANTITY'
                description='Label for quantity'
                defaultMessage='Quantity'
            />
        ),
        RIGHT: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.RIGHT'
                description='Label for right'
                defaultMessage='Right'
            />
        ),
        SETTINGS: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.SETTINGS'
                description='Label for settings'
                defaultMessage='Settings'
            />
        ),
        INVENTORY: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.INVENTORY'
                description='Label for inventory'
                defaultMessage='Inventory'
            />
        ),
        UTILIZATIONS: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.UTILIZATIONS'
                description='Label for utilizations'
                defaultMessage='Utilizations'
            />
        ),
        HEARTBEAT_TIMESTAMP: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.HEARTBEAT_TIMESTAMP'
                description='Label for last heartbeat timestamp'
                defaultMessage='Last heartbeat'
            />
        ),
        VERSION: (
            <FormattedMessage
                id='Objects.COMMON_FIELDS.VERSION'
                description='Label for software or firmware version'
                defaultMessage='Version'
            />
        )
    },
    MOVEMENT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.MOVEMENT.DEFAULT'
                description='Label for movement'
                defaultMessage='Movement'
            />
        ),
        ORIGINAL_QUANTITY: (
            <FormattedMessage
                id='Objects.MOVEMENT.ORIGINAL_QUANTITY'
                description='Label for original quantity'
                defaultMessage='Original quantity'
            />
        ),
        NEW_QUANTITY: (
            <FormattedMessage
                id='Objects.MOVEMENT.NEW_QUANTITY'
                description='Label for new quantity'
                defaultMessage='New quantity'
            />
        ),
        DIFFERENCE: (
            <FormattedMessage
                id='Objects.MOVEMENT.DIFFERENCE'
                description='Label for difference'
                defaultMessage='Difference'
            />
        )
    },
    USER: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.USER.DEFAULT'
                description='Label for user'
                defaultMessage='User'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.USER.PLURAL'
                description='Plural name for users'
                defaultMessage='Users'
            />
        ),
        ALIAS: (
            <FormattedMessage
                id='Objects.USER.ALIAS'
                description='Label for alias'
                defaultMessage='Alias'
            />
        ),
        EMAIL: (
            <FormattedMessage
                id='Objects.USER.EMAIL'
                description='Label for email'
                defaultMessage='Email'
            />
        ),
        MOBILE: (
            <FormattedMessage
                id='Objects.USER.MOBILE'
                description='Label for mobile'
                defaultMessage='Mobile'
            />
        ),
        LANGUAGE: (
            <FormattedMessage
                id='Objects.USER.LANGUAGE'
                description='Label for language'
                defaultMessage='Language'
            />
        ),
        FIRST_NAME: (
            <FormattedMessage
                id='Objects.USER.FIRST_NAME'
                description='Label for first name'
                defaultMessage='First name'
            />
        ),
        LAST_NAME: (
            <FormattedMessage
                id='Objects.USER.LAST_NAME'
                description='Label for last name'
                defaultMessage='Last name'
            />
        ),
        DEPARTMENT: (
            <FormattedMessage
                id='Objects.USER.DEPARTMENT'
                description='Label for department'
                defaultMessage='Department'
            />
        )
    },
    SPOT: {
        DISTRI_SPOT: (
            <FormattedMessage
                id='Objects.SPOT.DISTRI_SPOT'
                description='Label for distri spot'
                defaultMessage='distriSPOT'
            />
        ),
        DISTRI_SPOT_OUT: (
            <FormattedMessage
                id='Objects.SPOT.DISTRI_SPOT.OUT'
                description='Label for going out to distriSPOT'
                defaultMessage='distriSPOT (out)'
            />
        ),
        DISTRI_SPOTS: (
            <FormattedMessage
                id='Objects.SPOT.DISTRI_SPOTS'
                description='Label for distri spots'
                defaultMessage='distriSPOTs'
            />
        ),
        DEFAULT: (
            <FormattedMessage
                id='Objects.SPOT.DEFAULT'
                description='Label for spot'
                defaultMessage='SPOT'
            />
        ),
        DESTINATION: (
            <FormattedMessage
                id='Objects.SPOT.DESTINATION'
                description='Filter label for the destination SPOT of a parcel or transaction'
                defaultMessage='Destination SPOT'
            />
        )
    },
    MODULE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.MODULE.DEFAULT'
                description='Label for module'
                defaultMessage='Module'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.MODULE.PLURAL'
                description='Plural name for modules'
                defaultMessage='Modules'
            />
        ),
        TEMPLATE: (
            <FormattedMessage
                id='Objects.MODULE.TEMPLATE'
                description='Label for module template'
                defaultMessage='Module template'
            />
        ),
        TEMPLATE_PLURAL: (
            <FormattedMessage
                id='Objects.MODULE.TEMPLATE_PLURAL'
                description='Plural name for module templates'
                defaultMessage='Module templates'
            />
        ),
        GENERATOR: (
            <FormattedMessage
                id='Objects.MODULE.GENERATOR'
                description='Label for module generator'
                defaultMessage='Module generator'
            />
        ),
        DOOR: {
            DEFAULT: (
                <FormattedMessage
                    id='Objects.MODULE.DOOR'
                    description='Label for door'
                    defaultMessage='Door'
                />
            ),
            PLURAL: (
                <FormattedMessage
                    id='Objects.MODULE.DOOR_PLURAL'
                    description='Plural name for doors'
                    defaultMessage='Doors'
                />
            )
        },
        RENDERABLE: (
            <FormattedMessage
                id='Objects.MODULE.RENDERABLE'
                description='Label for whether a module is drawn in the SPOT layout'
                defaultMessage='Renderable'
            />
        )
    },
    CONSTRAINT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.CONSTRAINT.DEFAULT'
                description='Label for constraint'
                defaultMessage='Constraint'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.CONSTRAINT.PLURAL'
                description='Plural name for constraints'
                defaultMessage='Constraints'
            />
        ),
        CONSTRAINT_TYPE: (
            <FormattedMessage
                id='Objects.CONSTRAINT.TYPE'
                description='Label for constraint type'
                defaultMessage='Constraint type'
            />
        ),
        MODE: (
            <FormattedMessage
                id='Objects.CONSTRAINT.MODE'
                description='Label for constraint mode'
                defaultMessage='Constraint mode'
            />
        ),
        CONSTRAINT_NAME: (
            <FormattedMessage
                id='Objects.CONSTRAINT.NAME'
                description='Label for constraint name'
                defaultMessage='Constraint name'
            />
        )
    },
    TRANSACTION: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.TRANSACTION.DEFAULT'
                description='Label for transaction'
                defaultMessage='Transaction'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.TRANSACTION.PLURAL'
                description='Plural name for transactions'
                defaultMessage='Transactions'
            />
        ),
        TRACKING_NUMBER: (
            <FormattedMessage
                id='Objects.TRANSACTION.TRACKING_NUMBER'
                description='Label for tracking number'
                defaultMessage='Tracking number'
            />
        ),
        SHIPMENT: (
            <FormattedMessage
                id='Objects.TRANSACTION.SHIPMENT'
                description='Label for shipment'
                defaultMessage='Shipment'
            />
        ),
        ITEMS: (
            <FormattedMessage
                id='Objects.TRANSACTION.ITEMS'
                description='Label for items'
                defaultMessage='items'
            />
        ),
        SHIPMENTS: (
            <FormattedMessage
                id='Objects.TRANSACTION.SHIPMENTS'
                description='Label for shipments'
                defaultMessage='Shipments'
            />
        ),
        SHIPMENT_LABEL: (
            <FormattedMessage
                id='Objects.TRANSACTION.SHIPMENT_LABEL'
                description='Label for shipment label'
                defaultMessage='Shipment label'
            />
        ),
        SHIPMENT_BAG: (
            <FormattedMessage
                id='Objects.TRANSACTION.SHIPMENT_BAG'
                description='Label for shipment bag'
                defaultMessage='Shipment bag'
            />
        ),
        SHIPPING_NOTES: (
            <FormattedMessage
                id='Objects.TRANSACTION.SHIPPING_NOTES'
                description='Label for shipping notes'
                defaultMessage='Shipping notes'
            />
        ),
        COMMENTS: (
            <FormattedMessage
                id='Objects.TRANSACTION.COMMENTS'
                description='Label for comments'
                defaultMessage='Comments'
            />
        ),
        ACTOR: (
            <FormattedMessage
                id='Objects.TRANSACTION.ACTOR'
                description='Label for a transaction actor'
                defaultMessage='Actor'
            />
        ),
        ACTORS: (
            <FormattedMessage
                id='Objects.TRANSACTION.ACTORS'
                description='Label for transaction actors'
                defaultMessage='Actors'
            />
        ),
        SENDER: (
            <FormattedMessage
                id='Objects.TRANSACTION.SENDER'
                description='Label for sender'
                defaultMessage='Sender'
            />
        ),
        SENDERS: (
            <FormattedMessage
                id='Objects.TRANSACTION.SENDERS'
                description='Label for senders'
                defaultMessage='Senders'
            />
        ),
        DROPPED_OFF: (
            <FormattedMessage
                id='Objects.TRANSACTION.DROPPED_OFF'
                description='Label for dropped off'
                defaultMessage='Dropped off'
            />
        ),
        DROPPED_OFF_BY: (
            <FormattedMessage
                id='Objects.TRANSACTION.DROPPED_OFF_BY'
                description='Label for dropped off by'
                defaultMessage='Dropped off by'
            />
        ),
        DROPPED_OFF_AT: (
            <FormattedMessage
                id='Objects.TRANSACTION.DROPPED_OFF_AT'
                description='Label for dropped off at'
                defaultMessage='Dropped off at'
            />
        ),
        PICKED_UP: (
            <FormattedMessage
                id='Objects.TRANSACTION.PICKED_UP'
                description='Label for picked up'
                defaultMessage='Picked up'
            />
        ),
        PICKED_UP_BY: (
            <FormattedMessage
                id='Objects.TRANSACTION.PICKED_UP_BY'
                description='Label for picked up by'
                defaultMessage='Picked up by'
            />
        ),
        PICKED_UP_AT: (
            <FormattedMessage
                id='Objects.TRANSACTION.PICKED_UP_AT'
                description='Label for picked up at'
                defaultMessage='Picked up at'
            />
        ),
        DESTINATION: (
            <FormattedMessage
                id='Objects.TRANSACTION.DESTINATION'
                description='Label for Destination'
                defaultMessage='Destination'
            />
        ),
        DROP_OFF: (
            <FormattedMessage
                id='Objects.TRANSACTION.DROP_OFF'
                description='Label for drop-off'
                defaultMessage='Drop-off'
            />
        ),
        DROP_OFF_PACKAGE: (
            <FormattedMessage
                id='Objects.TRANSACTION.DROP_OFF_PACKAGE'
                description='Label for drop off package'
                defaultMessage='Drop off package'
            />
        ),
        DROP_OFF_STATE: (
            <FormattedMessage
                id='Objects.TRANSACTION.DROP_OFF_STATE'
                description='Label for drop-off state'
                defaultMessage='Drop-off state'
            />
        ),
        DROP_OFF_TIMESTAMP: (
            <FormattedMessage
                id='Objects.TRANSACTION.DROP_OFF_TIMESTAMP'
                description='Label for drop-off at'
                defaultMessage='Drop-off at'
            />
        ),
        SINCE_TIMESTAMP: (
            <FormattedMessage
                id='Objects.TRANSACTION.SINCE_TIMESTAMP'
                description='Label for since'
                defaultMessage='Since'
            />
        ),
        RECEIVER: (
            <FormattedMessage
                id='Objects.TRANSACTION.RECEIVER'
                description='Label for receiver'
                defaultMessage='Receiver'
            />
        ),
        RECEIVERS: (
            <FormattedMessage
                id='Objects.TRANSACTION.RECEIVERS'
                description='Label for receivers'
                defaultMessage='Receivers'
            />
        ),
        PICK_UP: (
            <FormattedMessage
                id='Objects.TRANSACTION.PICK_UP'
                description='Label for pick-up'
                defaultMessage='Pick-up'
            />
        ),
        PICK_UP_PACKAGE: (
            <FormattedMessage
                id='Objects.TRANSACTION.PICK_UP_PACKAGE'
                description='Label for pick-up package'
                defaultMessage='Pick-up package'
            />
        ),
        PICK_UP_STATE: (
            <FormattedMessage
                id='Objects.TRANSACTION.PICK_UP_STATE'
                description='Label for pick-up state'
                defaultMessage='Pick-up state'
            />
        ),
        PICK_UP_TIMESTAMP: (
            <FormattedMessage
                id='Objects.TRANSACTION.PICK_UP_TIMESTAMP'
                description='Label for pick-up at'
                defaultMessage='Pick-up at'
            />
        ),
        PURCHASE_ORDER: (
            <FormattedMessage
                id='Objects.TRANSACTION.PURCHASE_ORDER'
                description='Label for purchase order'
                defaultMessage='Purchase order'
            />
        ),
        NOTES: (
            <FormattedMessage
                id='Objects.TRANSACTION.NOTES'
                description='Label for notes'
                defaultMessage='Notes'
            />
        ),
        HISTORY: (
            <FormattedMessage
                id='Objects.TRANSACTION.HISTORY'
                description='Label for history'
                defaultMessage='History'
            />
        ),
        WAITING_FOR: (
            <FormattedMessage
                id='Objects.TRANSACTION.WAITING_FOR'
                description='Label for waiting time'
                defaultMessage='Waiting'
            />
        ),
        SHIPPING_LABEL: (
            <FormattedMessage
                id='Objects.TRANSACTION.SHIPPING_LABEL'
                description='Label for shipping label'
                defaultMessage='Shipping label'
            />
        ),
        CONTENT: (
            <FormattedMessage
                id='Objects.TRANSACTION.CONTENT'
                description='Label for content'
                defaultMessage='Content'
            />
        ),
        TRANSACTION_TYPE: (
            <FormattedMessage
                id='Objects.TRANSACTION.TRANSACTION_TYPE'
                description='Label for transaction type'
                defaultMessage='Transaction type'
            />
        ),
        AWAITING: (
            <FormattedMessage
                id='Objects.TRANSACTION.AWAITING'
                description='Label for awaiting'
                defaultMessage='Awaiting'
            />
        ),
        COMPLETED: (
            <FormattedMessage
                id='Objects.TRANSACTION.COMPLETED'
                description='Label for completed'
                defaultMessage='Completed'
            />
        ),
        HISTORY_LOG: {
            CREATED: (
                <FormattedMessage
                    id='Objects.TRANSACTION.HISTORY_LOG.CREATED'
                    description='History timeline label when a transaction was created'
                    defaultMessage='Transaction created'
                />
            ),
            COMPLETED: (
                <FormattedMessage
                    id='Objects.TRANSACTION.HISTORY_LOG.COMPLETED'
                    description='History timeline label when a transaction was completed'
                    defaultMessage='Transaction completed'
                />
            ),
            DROPPED_OFF: (
                <FormattedMessage
                    id='Objects.TRANSACTION.HISTORY_LOG.DROPPED_OFF'
                    description='History timeline label when a transaction was dropped off'
                    defaultMessage='Transaction dropped off'
                />
            ),
            PICKED_UP: (
                <FormattedMessage
                    id='Objects.TRANSACTION.HISTORY_LOG.PICKED_UP'
                    description='History timeline label when a transaction was picked up'
                    defaultMessage='Transaction picked up'
                />
            )
        },
        CANCELLED: (
            <FormattedMessage
                id='Objects.TRANSACTION.CANCELLED'
                description='Label for cancelled'
                defaultMessage='Cancelled'
            />
        ),
        RETURN_REASON: (
            <FormattedMessage
                id='Objects.PRODUCT.RETURN_REASON'
                description='Label for return reason'
                defaultMessage='Return reason'
            />
        )
    },
    IMPORT_LOG: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.IMPORT_LOG.DEFAULT'
                description='Label for import log'
                defaultMessage='Import log'
            />
        ),
        FILE_NAME: (
            <FormattedMessage
                id='Objects.IMPORT_LOG.FILE_NAME'
                description='Label for file name'
                defaultMessage='File name'
            />
        ),
        FILE_SIZE: (
            <FormattedMessage
                id='Objects.IMPORT_LOG.FILE_SIZE'
                description='Label for file size'
                defaultMessage='File size'
            />
        ),
        IMPORT_TYPE: (
            <FormattedMessage
                id='Objects.IMPORT_LOG.IMPORT_TYPE'
                description='Label for import type'
                defaultMessage='Import type'
            />
        ),
        IMPORT_ENTITY_TYPE: (
            <FormattedMessage
                id='Objects.IMPORT_LOG.IMPORT_ENTITY_TYPE'
                description='Label for import entity type'
                defaultMessage='Import entity type'
            />
        )
    },
    CERTIFICATE: {
        CODE: (
            <FormattedMessage
                id='Objects.CERTIFICATE.CODE'
                description='Label for certificate code'
                defaultMessage='Certificate code'
            />
        ),
        EQUIPMENT: (
            <FormattedMessage
                id='Objects.CERTIFICATE.EQUIPMENT'
                description='Label for certificatied equipment'
                defaultMessage='Certified equipment'
            />
        ),
        STATUS: (
            <FormattedMessage
                id='Objects.CERTIFICATE.STATUS'
                description='Label for Certificate status'
                defaultMessage='Certificate status'
            />
        ),
        EXPIRED_FOR: (
            <FormattedMessage
                id='Objects.CERTIFICATE.EXPIRED_FOR'
                description='Label for expired certificate'
                defaultMessage='Expired for'
            />
        ),
        DEFAULT: (
            <FormattedMessage
                id='Objects.CERTIFICATE.DEFAULT'
                description='Label for certificate'
                defaultMessage='Certificate'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.CERTIFICATE.PLURAL'
                description='Plural name for certificates'
                defaultMessage='Certificates'
            />
        ),
        TYPED_CERTIFICATE: TypedCertificate,
        EXPIRATION_DATE: (
            <FormattedMessage
                id='Objects.CERTIFICATE.EXPIRATION_DATE'
                description='Label for certificate expiration date'
                defaultMessage='Expiration date'
            />
        ),
        CERTIFICATE_NAME: (
            <FormattedMessage
                id='Objects.CERTIFICATE.NAME'
                description='Label for certificate name'
                defaultMessage='Certificate name'
            />
        )
    },
    CERTIFICATE_REQUIREMENT: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.CERTIFICATE_REQUIREMENT.DEFAULT'
                description='Label for certificate requirement'
                defaultMessage='Certificate requirement'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.CERTIFICATE_REQUIREMENT.PLURAL'
                description='Plural name for certificate requirements'
                defaultMessage='Certificate requirements'
            />
        )
    },
    COST_CENTER: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.COST_CENTER.DEFAULT'
                description='Label for cost center'
                defaultMessage='Cost center'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.COST_CENTER.PLURAL'
                description='Plural name for cost centers'
                defaultMessage='Cost centers'
            />
        )
    },
    ADDRESS: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.ADDRESS.DEFAULT'
                description='Label for address'
                defaultMessage='Address'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.ADDRESS.PLURAL'
                description='Label for addresses'
                defaultMessage='Addresses'
            />
        ),
        STREET: (
            <FormattedMessage
                id='Objects.ADDRESS.STREET'
                description='Label for address street'
                defaultMessage='Address street'
            />
        ),
        NUMBER: (
            <FormattedMessage
                id='Objects.ADDRESS.NUMBER'
                description='Label for address number'
                defaultMessage='Address number'
            />
        ),
        APARTMENT: (
            <FormattedMessage
                id='Objects.ADDRESS.APARTMENT'
                description='Label for address apartment'
                defaultMessage='Address apartment'
            />
        ),
        CITY: (
            <FormattedMessage
                id='Objects.ADDRESS.CITY'
                description='Label for address city'
                defaultMessage='Address city'
            />
        ),
        ZIP_CODE: (
            <FormattedMessage
                id='Objects.ADDRESS.ZIP_CODE'
                description='Label for address zip code'
                defaultMessage='Address zip code'
            />
        ),
        PROVINCE: (
            <FormattedMessage
                id='Objects.ADDRESS.PROVINCE'
                description='Label for address province'
                defaultMessage='Address province'
            />
        ),
        REGION: (
            <FormattedMessage
                id='Objects.ADDRESS.REGION'
                description='Label for address region'
                defaultMessage='Address region'
            />
        ),
        COUNTY: (
            <FormattedMessage
                id='Objects.ADDRESS.COUNTY'
                description='Label for address county'
                defaultMessage='Address county'
            />
        ),
        NOTE: (
            <FormattedMessage
                id='Objects.ADDRESS.NOTE'
                description='Label for address note'
                defaultMessage='Address note'
            />
        ),
        ADDRESS_TYPE: (
            <FormattedMessage
                id='Objects.ADDRESS.TYPE'
                description='Label for address type'
                defaultMessage='Address type'
            />
        ),
        BUILDING: (
            <FormattedMessage
                id='Objects.ADDRESS.BUILDING'
                description='Label for building'
                defaultMessage='Building'
            />
        )
    },
    PACKAGE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.PACKAGE.DEFAULT'
                description='Label for package'
                defaultMessage='Package'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.PACKAGE.PLURAL'
                description='Plural name for packages'
                defaultMessage='Packages'
            />
        ),
        HISTORY_LOG: {
            CREATED: (
                <FormattedMessage
                    id='Objects.PACKAGE.HISTORY_LOG.CREATED'
                    description='History timeline label when a package was created'
                    defaultMessage='Package created'
                />
            ),
            COMPLETED: (
                <FormattedMessage
                    id='Objects.PACKAGE.HISTORY_LOG.COMPLETED'
                    description='History timeline label when a package was completed'
                    defaultMessage='Package completed'
                />
            ),
            DROPPED_OFF: (
                <FormattedMessage
                    id='Objects.PACKAGE.HISTORY_LOG.DROPPED_OFF'
                    description='History timeline label when a package was dropped off'
                    defaultMessage='Package dropped off'
                />
            ),
            PICKED_UP: (
                <FormattedMessage
                    id='Objects.PACKAGE.HISTORY_LOG.PICKED_UP'
                    description='History timeline label when a package was picked up'
                    defaultMessage='Package picked up'
                />
            ),
            SLOT_NOT_OPENED: (
                <FormattedMessage
                    id='Objects.PACKAGE.HISTORY_LOG.SLOT_NOT_OPENED'
                    description='History timeline label when a package SLOT was not opened'
                    defaultMessage='Package SLOT not opened'
                />
            ),
            SLOT_NOT_CLOSED: (
                <FormattedMessage
                    id='Objects.PACKAGE.HISTORY_LOG.SLOT_NOT_CLOSED'
                    description='History timeline label when a package SLOT was not closed'
                    defaultMessage='Package SLOT not closed'
                />
            )
        }
    },
    CONSUME_QUESTIONNAIRE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.CONSUME_QUESTIONNAIRE.DEFAULT'
                description='Label for consume questionnaire'
                defaultMessage='Consume questionnaire'
            />
        )
    },
    RETURN_QUESTIONNAIRE: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.RETURN_QUESTIONNAIRE.DEFAULT'
                description='Label for return questionnaire'
                defaultMessage='Return questionnaire'
            />
        )
    },
    WIDGET: {
        DEFAULT: (
            <FormattedMessage
                id='Objects.WIDGET.DEFAULT'
                description='Label for widget'
                defaultMessage='Widget'
            />
        ),
        PLURAL: (
            <FormattedMessage
                id='Objects.WIDGET.PLURAL'
                description='Plural name for widgets'
                defaultMessage='Widgets'
            />
        )
    }
};

function PendingLinkMessage(type: string) {
    return (
        <FormattedMessage
            id='Objects.PENDING_LINK_MESSAGE'
            description='Pending link message'
            defaultMessage='Linking {type}s'
            values={{ type: type }}
        />
    );
}

function SuccessLinkMessage(type: string) {
    return (
        <FormattedMessage
            id='Objects.SUCCESS_LINK_MESSAGE'
            description='Success link message'
            defaultMessage='Successfully linked {type}s'
            values={{ type: type.replace(/_/g, ' ') }}
        />
    );
}

function ErrorLinkMessage(type: string) {
    return (
        <FormattedMessage
            id='Objects.ERROR_LINK_MESSAGE'
            description='Error link message'
            defaultMessage='Error while trying to link {type}s'
            values={{ type: type.replace(/_/g, ' ') }}
        />
    );
}

function PendingUnlinkMessage(type: string, count: number) {
    return (
        <FormattedMessage
            id='Objects.PENDING_UNLINK_MESSAGE'
            description='Pending unlink message'
            defaultMessage='Unlinking {count} {type}s'
            values={{ count: count, type: type.replace(/_/g, ' ') }}
        />
    );
}

function SuccessUnlinkMessage(type: string, count: number) {
    return (
        <FormattedMessage
            id='Objects.SUCCESS_UNLINK_MESSAGE'
            description='Success unlink message'
            defaultMessage='Successfully unlinked {count} {type}s'
            values={{ count: count, type: type.replace(/_/g, ' ') }}
        />
    );
}

function ErrorUnlinkMessage(type: string, count: number) {
    return (
        <FormattedMessage
            id='Objects.ERROR_UNLINK_MESSAGE'
            description='Error unlink message'
            defaultMessage='Error while trying to unlink {count} {type}s'
            values={{ count: count, type: type.replace(/_/g, ' ') }}
        />
    );
}

function TypedCertificate(type: React.ReactNode) {
    return (
        <FormattedMessage
            id='Objects.CERTIFICATE.TYPED'
            description='Typed certificate'
            defaultMessage='{type} Certificate'
            values={{ type: type }}
        />
    );
}

function PendingOpeningMessage(type: EntityType, name: React.ReactNode) {
    return (
        <FormattedMessage
            id='Objects.SLOT.PENDING_OPENING_MESSAGE'
            description='Pending opening message'
            defaultMessage='Opening {type} {name}'
            values={{ type: type.replace(/_/g, ' '), name: name }}
        />
    );
}

function SuccessOpeningMessage(type: EntityType, name: React.ReactNode) {
    return (
        <FormattedMessage
            id='Objects.SLOT.SUCCESS_OPENING_MESSAGE'
            description='Success opening message'
            defaultMessage='Successfully opened {type} {name}'
            values={{ type: type.replace(/_/g, ' '), name: name }}
        />
    );
}

function ErrorOpeningMessage(type: EntityType, name: React.ReactNode) {
    return (
        <FormattedMessage
            id='Objects.SLOT.ERROR_OPENING_MESSAGE'
            description='Error opening message'
            defaultMessage='Error while trying to open {type} {name}'
            values={{ type: type.replace(/_/g, ' '), name: name }}
        />
    );
}

function typedVariable(type: React.ReactNode) {
    return (
        <FormattedMessage
            id='Objects.TYPED_VARIABLE'
            description='Typed variable'
            defaultMessage='{type} Variable'
            values={{ type: type }}
        />
    );
}

function groupMemberAdd(count: number, singular: React.ReactNode, plural: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='Objects.GROUP_MEMBER.ADD'
            defaultMessage='Are you sure you want to add {count, plural, one {this {singular}} other {these {plural}}} to this group?'
            values={{ count: count, singular: singular, plural: plural }}
        />
    );
}
